import {
  Component,
  createEffect,
  createMemo,
  createSignal,
  For,
  Show,
} from "solid-js";
import { Portal } from "solid-js/web";
import { event } from "../events";
import { api, Article } from "../helpers";
import { useStore } from "../state";

export const CreateListComponent: Component = () => {
  const { myLists } = useStore();
  const [newListTitle, setNewListTitle] = createSignal("");
  const [newListDescription, setNewListDescription] = createSignal("");

  return (
    <div class="my-4">
      <p>Create topic</p>
      <form
        onSubmit={async (e) => {
          e.preventDefault();

          const [list, err] = await api("/list/create", {
            title: newListTitle(),
            description: newListDescription(), // todo: ask description
          });

          if (!err) {
            myLists.refresh();
            event("List Created", {
              account_id: list.account_id,
              list_id: list.id,
              list_title: list.title,
              list_description: list.description,
            });
            setNewListTitle("");
            setNewListDescription("");
          }
        }}
      >
        <div class="flex">
          <input
            type="text"
            class="w-full rounded border-gray-300 shadow-sm
      rounded-r-none border-r-0"
            required
            minLength={1}
            value={newListTitle()}
            onInput={(e) => {
              setNewListTitle(e.currentTarget.value);
            }}
          />
          <input
            type="submit"
            class="bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
      rounded-l-none"
            value="Create"
          />
        </div>
      </form>
    </div>
  );
};

// TODO: Show something appropriate to logged out users
export const StarButton: Component<{ a: Article; onClose?: () => void }> = (
  p
) => {
  const { myLists, userId } = useStore();

  const starredList = createMemo(() =>
    myLists().find((l) => l.title === "Starred")
  );
  const articleStarred = createMemo(() =>
    myLists().some((i) => i.articles?.some((x) => x === p.a.id))
  );

  const [saveModal, setSaveModal] = createSignal(false);

  createEffect<ReturnType<typeof saveModal>>((modalOpen) => {
    if (modalOpen && !saveModal()) p.onClose?.();

    return saveModal();
  }, saveModal());

  return (
    <>
      <div class="flex bg-white border border-gray-300 rounded-md shadow-sm divide-x">
        <Show when={starredList()}>
          {(l) => (
            <button
              type="button"
              class="py-2 px-3 rounded-l-md text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              disabled={articleStarred()}
              onClick={async () => {
                const [, err] = await api("/lists/add", {
                  list: l.id,
                  article: p.a.id,
                });

                if (!err) {
                  event("List Entry Created", {
                    account_id: userId() as string,
                    list_id: l.id,
                    list_title: l.title,
                    article_id: p.a.id,
                  });
                }
                myLists.refresh();
              }}
            >
              {articleStarred() ? "⭐️" : "☆"}
            </button>
          )}
        </Show>
        <button
          type="button"
          class="py-2 px-3 rounded-r-md text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSaveModal(true);
            // setShowSaveModal(a);
          }}
        >
          <svg width="10" height="10">
            <polyline points="0, 3 5, 10 10, 3" fill="grey" />
          </svg>
        </button>
      </div>
      <Show when={saveModal()}>
        {(x) => (
          <Portal>
            <div
              class="modal-overlay"
              id="modal-overlay"
              onClick={() => setSaveModal(false)}
            />

            <div class="modal" id="modal">
              <button
                class="close-button bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={() => setSaveModal(false)}
              >
                Close
              </button>
              <div class="modal-guts pt-8">
                <div>
                  Add <span class="font-semibold italic">{p.a.title}</span> to
                  your topics.
                </div>
                <div class="mt-8 space-y-4 overflow-y-auto">
                  <For each={myLists()}>
                    {(l) => {
                      const articleInList = l.articles?.includes(p.a.id);
                      return (
                        <div class="flex justify-between">
                          <div>
                            {l.title} ({l.articles?.length})
                          </div>
                          <button
                            onClick={async () => {
                              const payload = {
                                list: l.id,
                                article: p.a.id,
                              };

                              if (articleInList) {
                                const [, err] = await api(
                                  "/lists/remove",
                                  payload
                                );
                                if (!err)
                                  event("List Entry Deleted", {
                                    account_id: userId() as string,
                                    list_id: l.id,
                                    list_title: l.title,
                                    article_id: p.a.id,
                                  });
                              } else {
                                const [, err] = await api(
                                  "/lists/add",
                                  payload
                                );
                                if (!err)
                                  event("List Entry Created", {
                                    account_id: userId() as string,
                                    list_id: l.id,
                                    list_title: l.title,
                                    article_id: p.a.id,
                                  });
                              }

                              // todo: show error

                              myLists.refresh();
                            }}
                            class="bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            {articleInList ? "Remove" : "Add"}
                          </button>
                        </div>
                      );
                    }}
                  </For>
                </div>
                <CreateListComponent />
              </div>
            </div>
          </Portal>
        )}
      </Show>
    </>
  );
};
